module.exports = __webpack_public_path__ + "bb590e2265ffe4c36837c40bd619eafd.pdf";